<template>
  <div id="addnewgr">

    <vs-popup title="Update Status" :active.sync="updateStatusTrigger">
      <updateStatus @result="(val) => closeWindow(val)" @refreshTable="(val) => refreshTable(val)" :rowId="curentRowId" />
    </vs-popup>

    <div v-if="showWizard" class=" ">
      <wizard @close="showWizard = false"></wizard>
    </div>
    <div v-else class="flex flex-wrap-reverse items-center">
      <template v-if="getGrGroup.length > 0">
        <vx-card :title="val.grNumber + ' - Item ' + val.itemNumber + ' - ' + val.status" class="mb-base m-5"
          v-for="(val, index) in getGrGroup">

          <!-- Avatar -->
          <div class="vx-row">

            <!-- Information - Col 1 -->
            <div class="vx-col flex-1" id="account-info-col-1">

              <table>
                <tr>
                  <td class="font-semibold">Company</td>
                  <td>{{ val.compId }}</td>
                </tr>
                <tr v-if="val.masterStockCode">
                  <td class="font-semibold">Master Stock Code</td>
                  <td>{{ val.masterStockCode.label }}</td>
                </tr>
                <tr v-if="val.subStockCode">
                  <td class="font-semibold">Sub Stock Code</td>
                  <td>{{ val.subStockCode.label }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Stock</td>
                  <td>{{ val.stock }}</td>
                </tr>
                <tr v-if="val.lineDescription">
                  <td class="font-semibold">Line Description</td>
                  <td>{{ val.lineDescription }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Remarks</td>
                  <td>{{ val.remarks }}</td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 1 -->

            <!-- Information - Col 2 -->
            <div class="vx-col flex-1" id="account-info-col-2">
              <table>
                <tr>
                  <td class="font-semibold">Qty Received</td>
                  <td>{{ val.qtyReceived }}</td>
                </tr>
                <tr v-if="val.supplier">
                  <td class="font-semibold">Supplier</td>
                  <td>{{ val.supplier.label }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Supplier Doc. No.</td>
                  <td>{{ val.supplierDocNumber }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Size Dimension</td>
                  <td>{{ val.sizeDimension }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Thickness</td>
                  <td>{{ val.thickness }}</td>
                </tr>
                <tr v-if="val.others">
                  <td class="font-semibold">Others</td>
                  <td>{{ val.others.label }}</td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 2 -->

            <div class="vx-col pull-right" id="account-info-col-2">
              <template v-if="val.masterStockCode && val.subStockCode">
                <VueQRCodeComponent class="p-2 bg-white pull-right" error-level="L"
                  :text="val.masterStockCode.label + '|' + val.subStockCode.label" :size="300" />
              </template>

            </div>

            <div class="vx-col w-full flex" id="account-manage-buttons">
              <vs-button v-if="val.status != 'Complete'" type="border" color="danger" icon-pack="feather"
                icon="icon-trash" @click="openConfirm(val.id)">Delete</vs-button>
              &nbsp;&nbsp;
              <vs-button v-if="val.status != 'Complete'" type="border" color="success" icon-pack="feather"
                icon="icon-pencil" @click="openWizard(val)">Edit</vs-button>
              &nbsp;&nbsp;
              <vs-button v-if="val.status == 'Verified' || val.status == 'Quarantine'" type="border" color="primary"
                icon-pack="feather" icon="icon-pencil" @click="updateStatusOfRecord(val)">Update Status</vs-button>
            </div>
          </div>
        </vx-card>
      </template>


      <vs-row class="pt-10  " v-else>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-alert color="success" title="Add New" active="true" class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
            Click the Plus Icon to add a new item
          </vs-alert>

        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button @click="$emit('close')" color="primary" type="border" icon-pack="feather"
            icon="icon-arrow-left"></vs-button>
          &nbsp;&nbsp;
          <vs-button @click="addNew" color="primary" type="border" icon-pack="feather" icon="icon-plus"></vs-button>
        </vs-col>
      </vs-row>

    </div>

  </div>
</template>
<script>
import wizard from "./wizard.vue";
import { mapGetters } from "vuex";
import { axiosMixin } from "@/mixin/axiosMixin.js";
import { alertMixin } from "@/mixin/alertMixin.js";
import VueQRCodeComponent from 'vue-qrcode-component'
import updateStatus from "./updateStatus";
export default {
  mixins: [axiosMixin, alertMixin],
  components: {
    wizard,
    VueQRCodeComponent,
    updateStatus
  },
  computed: {
    ...mapGetters({
      getGr: "main/getGr",
      getGrGroup: "main/getGrGroup",
      getUserInfo: "auth/getUserInfo",
    }),
  },
  props: {
    showWizardOnStartup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showWizard: false,
      updateStatusTrigger: false,
      curentRowId: '',
      currentSelectedData: {},
    };
  },
  methods: {
    closeWindow() {
      this.updateStatusTrigger = false;
    },
    refreshTable(val) {
      this.updateStatusTrigger = false;
      this.currentSelectedData.status = val.status
      //this.getData("update status");
    },
    updateStatusOfRecord(row) {
      console.log("row:", row.id);
      this.curentRowId = row.id;
      this.currentSelectedData = row;
      //  row.status = 'Complete';
      this.updateStatusTrigger = true;
    },
    openConfirm(id) {
      this.confirmAlert('Confirm Delete ', 'Are you sure you want to delete this Item?').then(res => {
        this.aronDelete('goodsreceives', id, "Item Deleted!")
          .then(response => {
            var newGroup = this.getGrGroup.filter(obj => obj.id !== id);
            console.log("newGroup:", newGroup);
            this.$store.dispatch("main/setGrGroup", newGroup);
            console.log("in delete response: ", this.getGrGroup);
          })
          .catch(error => {
            console.log("in elete error: ", error);
          });
      });
    },
    openWizard(val) {
      console.log("where are we: ", val);
      this.$store.dispatch("main/setGrData", val);
      this.$store.state.main.grCurrentOperation = 'update';
      this.$store.state.main.grCurrentItemOperation = 'update';
      this.$store.state.main.currentGrNumber = val.grNumber
      this.showWizard = true;
    },
    acceptAlert() {
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted image',
        text: 'The selected image was successfully deleted'
      })
    },
    acceptAlert() {
      this.aron
    },
    addNew() {
      this.$store.dispatch("main/addItemToGrData",
        {
          compId: '',
          masterStockCode: '',
          subStockCode: '',
          stock: '',
          supplier: '',
          qtyReceived: '',
          supplierDocNumber: '',
          receivedDate: '',
          unit: 'pcs',
          stockBalance: '',
          remarks: '',
          others: '',
          receivedBy: this.getUserInfo.name,
          id: '',
          grNumber: '',

        });
      this.showWizard = true;
      this.$store.state.main.grCurrentItemOperation = 'add';
    }
  },
  mounted() {

    this.showWizard = this.showWizardOnStartup;
    if (this.showWizardOnStartup) {
      this.$store.state.main.grCurrentOperation = 'update';
    }
  }
};
</script>
<style lang="scss">
#avatar-col {
  width: 10rem;
}

#addnewgr {
  table {
    td {
      vertical-align: top;
      min-width: 180px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}
</style>
